module.exports = __webpack_public_path__ + "img/SMS15064-L-min.068bb05b.png";